import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import CargoService from '../../../../../services/cargos';
import { Link } from 'react-router-dom';

const FormBusca = (props) => {
    const [nome, setNome] = useState("");
    const [matricula, setMatricula] = useState("");
    const [cargo, setCargo] = useState("");
    const [listaCargos, setListaCargos] = useState([]);

    // Carregar cargos do backend
    async function fetchCargos() {
        const res = await CargoService.listar();
        setListaCargos(res.data);
    }

    useEffect(() => {
        fetchCargos();
    }, []);

    // A cada mudança → aplicar filtro local
    const handleNomeChange = (e) => {
        const value = e.target.value;
        setNome(value);
        props.filtrarLocalmente(value, matricula, cargo);
    };

    const handleMatriculaChange = (e) => {
        const value = e.target.value;
        setMatricula(value);
        props.filtrarLocalmente(nome, value, cargo);
    };

    const handleCargoChange = (e) => {
        const value = e.target.value;
        setCargo(value);
        props.filtrarLocalmente(nome, matricula, value);
    };

    const limpar = () => {
        setNome("");
        setMatricula("");
        setCargo("");
        props.fetchFuncionarios(); // restaura lista original
    };

    return (
        <Fragment>
            <Container className="da-espaco">

                <Row xs={1} lg={3}>

                    <Col>
                        <FloatingLabel label="Nome do Funcionário" className="mb-3">
                            <Form.Control
                                type="text"
                                value={nome}
                                onChange={handleNomeChange}
                            />
                        </FloatingLabel>
                    </Col>

                    <Col>
                        <FloatingLabel label="Matrícula" className="mb-3">
                            <Form.Control
                                type="text"
                                value={matricula}
                                onChange={handleMatriculaChange}
                            />
                        </FloatingLabel>
                    </Col>

                    <Col>
                        <FloatingLabel label="Cargo" className="mb-3">
                            <Form.Select value={cargo} onChange={handleCargoChange}>
                                <option value="">Todos</option>
                                {listaCargos.map((c, i) => (
                                    <option key={i} value={c.cargo}>{c.cargo}</option>
                                ))}
                            </Form.Select>
                        </FloatingLabel>
                    </Col>

                </Row>
                <Row className="mt-2">
                    <Col xs={6} lg={2}>
                        <Button
                            type="button"
                            variant="danger"
                            className="botao-alto"
                            onClick={limpar}
                        >
                            Limpar Busca
                        </Button>
                    </Col>
                    <Col xs={6} lg={2}>
                        <Link to={'/rh/funcionarios'}>
                            <Button variant="danger" className="botao-alto" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default FormBusca;